import { NavigationSection } from "@inductiveautomation/ws-components";
import { TFunction } from "i18next";
import { omit } from "lodash";
import { TranslateKey } from "../../i18n/i18n.types.ts";

const navigationSections: NavigationSection[] = [
  {
    labelKey: "navigation.section.account",
    showDivider: true,
    items: [
      {
        id: "navigation-profile",
        to: "/profile",
        icon: "person-outlined",
        iconSelected: "person",
        labelKey: "navigation.profile",
      },
      {
        id: "navigation-email-preferences",
        to: "/email-preferences",
        icon: "email-outlined",
        iconSelected: "email",
        labelKey: "navigation.email_preferences",
      },
      {
        id: "navigation-organizations",
        to: "/organizations",
        icon: "organization-inverse",
        iconSelected: "organization",
        labelKey: "navigation.organizations",
      },
    ],
  },
  {
    labelKey: "navigation.section.products",
    showDivider: false,
    items: [
      {
        id: "navigation-maker-licenses",
        to: "/maker-licenses",
        icon: "license-outlined",
        iconSelected: "license",
        labelKey: "navigation.maker_licenses",
      },
      {
        id: "navigation-training",
        to: "/training",
        icon: "school-outlined",
        iconSelected: "school",
        labelKey: "navigation.training",
      },
    ],
  },
];

export const translatedSections = (
  t: TFunction,
  excludedPaths: Record<string, boolean> = {}
): NavigationSection[] =>
  navigationSections.map(
    (section) =>
      ({
        ...section,
        label: section.labelKey
          ? t(section.labelKey as TranslateKey)
          : undefined,
        items: section.items
          .filter(({ to }) => !excludedPaths[to as string])
          .map((item) => ({
            ...omit(item, "labelKey"),
            label: t(item.labelKey as TemplateStringsArray),
          })),
      }) as NavigationSection
  );
